export const isValidZipCode = ({ validZip } = {}) => validZip

export const isZipCodeInService = ({ inService } = {}) => inService
